import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import CheckboxButton from 'Components/ComponentLibrary/Components/Uncategorized/CheckboxButton';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 2),
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  text: {
    marginBottom: theme.spacing(4),
    lineHeight: 1.75,
  },
});

function PicklistDemoInfoScreen({
  classes,
  title,
  titleVariant,
  subtitle,
  text,
  questionText,
  options,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  const [demoCheckedValues, setDemoCheckedValues] = React.useState(Array(3).fill(false));

  if (!resource) return null;

  return (
    <div className={classes.root}>

      <Typography
        variant={titleVariant}
        color="primary"
        className={classes.title}
        weight="medium"
        align="center"
      >
        {title}
      </Typography>

      <Typography
        variant="h3"
        color="accentBlue19"
        className={classes.subtitle}
        weight="medium"
        align="center"
      >
        {subtitle}
      </Typography>

      <Typography
        className={classes.text}
        color="primaryGray2"
        variant="h4"
        weight="book"
        align="center"
      >
        {text}
      </Typography>

      <Typography
        className={classes.text}
        color="primaryGray2"
        variant="h4"
        weight="book"
        align="center"
      >
        {questionText}
      </Typography>

      {options.map((el, i) => (
        <CheckboxButton
          label={el}
          checked={demoCheckedValues[i]}
          onChange={() => setDemoCheckedValues(prev => {
            const previousValues = [...prev];
            previousValues[i] = !previousValues[i];
            return previousValues;
          })}
        />
      ))}

    </div>
  );
}

PicklistDemoInfoScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  questionText: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};

PicklistDemoInfoScreen.defaultProps = {
  titleVariant: 'h1',
};

export default withStyles(styles)(PicklistDemoInfoScreen);
